import { ReactElement } from 'react';
import { useRouter } from 'next/router';
import { Trans, useTranslation } from 'next-i18next';
import get from 'lodash/get';

import { LanguageCode } from '@Hotels-at-Home/hah-fe-core/dist/constants';
import Article from '~/ui/components/layouts/Article';
import { getRoutePostLink, generateLinkComponents } from '~/utils/blog';
import { postData } from '~/constants/blog';

const Post2 = (): ReactElement => {
  const { t: tArticle } = useTranslation('', { keyPrefix: '$local.$articles.$article2' });
  const { t: tNext } = useTranslation('', { keyPrefix: '$local.$articles.$article3' });

  const router = useRouter();
  const locale = router.locale as LanguageCode;

  const currentPostId = 2;
  const lastPostId = 3;

  let lastPostUrl = get(postData, [lastPostId, 'urls', locale]);
  lastPostUrl = getRoutePostLink(lastPostUrl, locale);

  const articleData = {
    id: currentPostId,
    hero: {
      heading: tArticle('title'),
      text: tArticle('subTitle'),
    },
    last: {
      url: lastPostUrl,
      id: lastPostId,
      heading: tNext('title'),
      text: tNext('subTitleCopy'),
      cta: tArticle('nextCta'),
    },
  };

  return (
    <Article id={articleData.id} hero={articleData.hero} last={articleData.last}>
      <h2>{tArticle('paragraphTitle1')}</h2>
      <p>
        <Trans
          i18nKey="paragraphText1"
          t={tArticle}
          components={{
            br: <br />,
            strong: <strong />,
            ...generateLinkComponents(tArticle, 1, 10),
          }}
        />
      </p>
      <h2>{tArticle('paragraphTitle2')}</h2>
      <p>
        <Trans
          i18nKey="paragraphText2"
          t={tArticle}
          components={{
            br: <br />,
            strong: <strong />,
          }}
        />
      </p>
      <h2>{tArticle('paragraphTitle3')}</h2>
      <p>
        <Trans
          i18nKey="paragraphText3"
          t={tArticle}
          components={{
            br: <br />,
            strong: <strong />,
            ...generateLinkComponents(tArticle, 11, 11),
          }}
        />
      </p>
      <h2>{tArticle('paragraphTitle4')}</h2>
      <p>
        <Trans
          i18nKey="paragraphText4"
          t={tArticle}
          components={{
            br: <br />,
            strong: <strong />,
            ...generateLinkComponents(tArticle, 10, 10),
          }}
        />
      </p>
      <h2>{tArticle('paragraphTitle5')}</h2>
      <p>
        <Trans
          i18nKey="paragraphText5"
          t={tArticle}
          components={{
            br: <br />,
            strong: <strong />,
          }}
        />
      </p>

      <p className="closing">
        <Trans
          i18nKey="paragraphText6"
          t={tArticle}
          components={{
            br: <br />,
            strong: <strong />,
          }}
        />
      </p>
    </Article>
  );
};

export default Post2;
